/* eslint-disable react/no-array-index-key */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const Sale = `${process.env.PUBLIC_URL}/img/event_placeholders/catalog/sale_lable.png`;
const New = `${process.env.PUBLIC_URL}/img/event_placeholders/catalog/new_lable.png`;

export default class Assets extends PureComponent {
  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
      src: PropTypes.string,
      title: PropTypes.string,
      price: PropTypes.string,
      description: PropTypes.string,
      colors: PropTypes.arrayOf(PropTypes.string),
      new: PropTypes.bool,
    })),
  };

  static defaultProps = {
    items: [],
  };

  render() {
    const { items } = this.props;

    return (
      <div className="asset-items__wrap">
        <div className="asset-items">
          {items.map((item, i) => (
            <div className="asset-item" key={i}>
              <Link className="asset-item__link" to="/e-commerce/product_page">
                {item.new ? <img className="asset-item__label" src={New} alt="new" /> : ''}
                {item.sale ? <img className="asset-item__label" src={Sale} alt="sale" /> : ''}
                <div className="asset-item__img-wrap">
                  <img className="asset-item__img" src={item.src} alt="asset-item-img" />
                </div>
                <div className="asset-item__info">
                  <h4 className="asset-item__title">{item.title}</h4>
                  <p className="asset-item__description">{item.description}</p>
                  <h1 className="asset-item__price">${item.price}</h1>
                  {item.sale ? <p className="asset-item__old-price">${item.oldPrice}</p> : ''}
                  {item.colors.map((c, index) => (
                    <span
                      key={index}
                      className="asset-item__color"
                      style={{ background: c }}
                    />
                  ))}
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    );
  }
}
